export default __webpack_public_path__ + "static/media/greenBayPackers@2x.319bdb59.jpg";